import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { setThemeColor } from './app/utils/util';

if (environment.production) {
  enableProdMode();
}

// The template originally picked a theme at runtime with a dynamic import of the
// .scss, which the Angular 19 builder cannot resolve. The theme is compiled in
// via angular.json instead; this only keeps localStorage in sync with it.
setThemeColor(environment.defaultColor);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
